// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Bell: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 52"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M42.5 40.6v-.2L37 35.1V20.4c0-6.8-4.6-12.9-11.1-14.8V1c0-.4-.3-.8-.8-.8H18c-.4 0-.8.3-.8.8v4.6C10.5 7.6 6 13.5 6 20.4V35L.7 40.3c-.2.2-.2.4-.2.6v3.7c0 .4.3.8.8.8h12c.5 3.6 3.7 6.3 7.4 6.3 3.6 0 6.8-2.7 7.4-6.3h13.7c.4 0 .8-.3.8-.8v-3.7c-.1-.1-.1-.2-.1-.3zm-16.7 4.7c-.5 2.4-2.6 4.1-5.1 4.1-2.5 0-4.6-1.7-5.1-4.1h10.2zM8.4 27.2v-6.9c0-7.3 5.9-13.1 13.1-13.1s13.2 5.9 13.2 13.1v6.9H8.4zm15.1-22c-.7-.1-1.4-.2-2-.2s-1.3.1-2 .2V2.5h4.1v2.7zM8.4 32v-2.5h26.4V32H8.4zm26.3 4v.2l5.5 5.3V43H2.8v-1.5l5.3-5.3c.2-.2.2-.4.2-.6v-1.3h26.4V36z"/></svg>;
};

export default React.memo(Bell);
